import { MinimalAuthorInfo } from 'client/shared/types/author'

export function authorsAsString(authors: MinimalAuthorInfo[] = []): string {
  return authors.map(a => a.name).join(', ')
}
